const getters = {
  getPPOBTransactions: (state) => state.ppob_transactions,
  getPPOBTransaction: (state) => state.ppob_transaction,
};

export default getters;